const Basket = () => {

    const hideMetaItems = document.querySelectorAll('.woocommerce-order .woocommerce-table__product-name .wc-item-meta li');

    if(hideMetaItems) {
        for(var i = 0; i < hideMetaItems.length; i++) {
            if(hideMetaItems[i].innerHTML.indexOf("Zgoda") !== -1) {
                hideMetaItems[i].classList.add('hidden');
            }

        }
    }

    // Remove all (0,00 zł)

    const allPricesRemove = document.querySelectorAll('.woocommerce-cart-form .variation dd p');

    if(allPricesRemove) {

        for(var i = 0; i < allPricesRemove.length; i++) {

            let withoutPrice = allPricesRemove[i].innerHTML.replace('(0,00&nbsp;zł)','');
            allPricesRemove[i].innerHTML = withoutPrice;
        }

    }

}

export default Basket;